import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { ArrowRight, Calculator, TrendingUp, BrainCircuit, LineChart } from 'lucide-react';
import { Search, MapPin, Users, X, FileText, ExternalLink, Mail, ArrowUpDown } from 'lucide-react';
import { newsletterService } from '../services/api'
import Papa from 'papaparse';
import { Alert, AlertTitle, AlertDescription } from './ui/alert';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "./ui/card"
import InteractiveMap from './ui/interactivemap';

const LandingPage = () => {
  const [zipCode, setZipCode] = useState('');
  const navigate = useNavigate();
  const { user } = useAuth();
  const [formData, setFormData] = useState({
    email: '',
    firstName: '',
    lastName: ''
  });

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <header className="bg-blue-600 text-white py-16">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl font-bold mb-4">Welcome to Cilxchange</h1>
          <p className="text-xl mb-8">
            Empowering independence through connection, support, and community.
          </p>
          
          {/* Search Box */}
          <div className="max-w-md bg-white rounded-lg p-4 shadow-lg">
            <label htmlFor="zipcode" className="block text-gray-700 mb-2">
              Find Centers for Independent Living near you
            </label>
            <div className="flex gap-2">
              <input
                type="text"
                id="zipcode"
                placeholder="Enter ZIP code"
                className="flex-1 p-2 border rounded text-gray-800"
                value={zipCode}
                onChange={(e) => setZipCode(e.target.value)}
              />
              <button className="bg-blue-700 text-white px-6 py-2 rounded hover:bg-blue-800">
                Search
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="container mx-auto px-4 py-12">
        {/* Features Section */}
        <section className="grid md:grid-cols-3 gap-8 mb-16">
          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <MapPin className="text-blue-600" />
                Find Your Local CIL
              </CardTitle>
            </CardHeader>
            <CardContent>
              <CardDescription>
                Locate Centers for Independent Living in your area and connect with valuable resources and support services.
              </CardDescription>
            </CardContent>
          </Card>


          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <FileText className="text-blue-600" />
                Personal Profile Control
              </CardTitle>
            </CardHeader>
            <CardContent>
              <CardDescription>
                Create and manage your profile, controlling your information and journey through services with complete privacy.
              </CardDescription>
            </CardContent>
          </Card>
          

          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <Users className="text-blue-600" />
                Peer Support Network
              </CardTitle>
            </CardHeader>
            <CardContent>
              <CardDescription>
                Connect with peer support groups and build relationships with others who understand your journey.
              </CardDescription>
            </CardContent>
          </Card>
        </section>

        {/* Map Section */}
        <section className="mb-16">
          <h2 className="text-2xl font-bold mb-6">Find Centers for Independent Living</h2>
          <InteractiveMap />
        </section>

        {/* Call to Action */}
        {/*
        <Alert className="bg-blue-50 border-blue-200">
          <AlertTitle className="text-blue-800 text-xl mb-2">
            Ready to Begin Your Journey?
          </AlertTitle>
          <AlertDescription className="text-blue-700">
            Join Cilxchange today to access personalized support, connect with your local CIL, and take control of your independent living journey.
            <div className="mt-4">
              <button onClick={() => navigate('/consumers')} className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700 flex items-center gap-2">
                Get Started
                <ArrowRight size={16} />
              </button>
            </div>
          </AlertDescription>
        </Alert>
        */}
        
        <div className="mt-5 max-w-md mx-auto sm:flex sm:justify-center md:mt-8">
          <div className="mt-3 sm:mt-0 sm:ml-3">
            <button
              onClick={() => navigate('/login')}
              className="w-full flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-blue-600 bg-white hover:bg-gray-50 md:py-4 md:text-lg md:px-10"
            >
              Sign In
            </button>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-gray-800 text-white py-8">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-3 gap-8">
            <div>
              <h3 className="font-bold mb-4">About Cilxchange</h3>
              <p className="text-gray-300">
                Empowering individuals with disabilities to live independently through connection and support.
              </p>
            </div>
            <div>
              <h3 className="font-bold mb-4">Quick Links</h3>
              <ul className="text-gray-300">
                <li className="mb-2">Find a CIL</li>
                <li className="mb-2">Create Profile</li>
                <li className="mb-2">Support Groups</li>
                <li className="mb-2">Resources</li>
              </ul>
            </div>
            <div>
              <h3 className="font-bold mb-4">Contact</h3>
              <p className="text-gray-300">
                Email: info@Cilxchange.org<br />
                Phone: (555) 123-4567<br />
                Hours: Mon-Fri 9am-5pm EST
              </p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;